<template>
    <div>
        <ubi-panel>
            <el-container>
                <el-aside width="30%">
                    <h3>{{ $t("posts.edit.interiorTitle") }}</h3>
                </el-aside>
                <el-container>
                    <el-main>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item
                                        :label="$labels.nombre_etages"
                                        prop="nombre_etages"

                                >
                                    <el-input v-mask="'#################'" v-model.number="post.nombre_etages"
                                              type="nombre_etages"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item
                                        :label="$labels.etage"
                                        prop="etage"

                                >
                                    <el-input v-mask="'#################'" v-model.number="post.etage"
                                              type="etage"></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="8">
                                <br><br>
                                <el-checkbox v-model="post.duplex" true-label="oui" false-label="non">{{$labels.duplex}}
                                </el-checkbox>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item
                                        :label="$labels.nb_pieces_logement"
                                        prop="nb_pieces_logement"

                                >
                                    <el-input v-mask="'#################'" v-model.number="post.nb_pieces_logement"
                                              type="nb_pieces_logement"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item
                                        :label="$labels.nombre_de_chambres"
                                        prop="nombre_de_chambres"

                                >
                                    <el-input v-mask="'#################'" v-model.number="post.nombre_de_chambres"
                                              type="nombre_de_chambres"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item
                                        :label="$labels.nb_salles_d_eau"
                                        prop="nb_salles_d_eau"

                                >
                                    <el-input v-mask="'#################'" v-model.number="post.nb_salles_d_eau"
                                              type="nb_salles_d_eau"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item
                                        :label="$labels.nb_salles_de_bain"
                                        prop="nb_salles_de_bain"

                                >
                                    <el-input v-mask="'#################'" v-model.number="post.nb_salles_de_bain"
                                              type="nb_salles_de_bain"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item
                                        :label="$labels.nb_wc"
                                        prop="nb_wc"

                                >
                                    <el-input v-mask="'#################'" v-model.number="post.nb_wc"
                                              type="nb_wc"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                {{ $t("posts.edit.interiorServices") }} :<br>
                                <br>
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox v-model="post.wc_independant" true-label="oui" false-label>
                                    {{$labels.wc_independant}}
                                </el-checkbox>
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox v-model="post.sejour" true-label="oui" false-label="non">
                                    {{ $labels.sejour }}
                                </el-checkbox>
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox v-model="post.salle_a_manger" true-label="oui" false-label="non">
                                    {{ $labels.salle_a_manger }}
                                </el-checkbox>
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox v-model="post.coin_bureau" true-label="oui" false-label="non">
                                    {{$labels.coin_bureau}}
                                </el-checkbox>
                            </el-col>
                            <el-col :span="12">
                              <el-checkbox v-model="post.veranda" true-label="oui" false-label="non">
                                {{ $labels.veranda }}
                              </el-checkbox>
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox v-model="post.degagement" true-label="oui" false-label="non">
                                    {{$labels.degagement}}
                                </el-checkbox>
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox v-model="post.dressing" true-label="oui" false-label="non">
                                    {{$labels.dressing}}
                                </el-checkbox>
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox v-model="post.buanderie" true-label="oui" false-label="non">
                                    {{ $labels.buanderie }}
                                </el-checkbox>
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox v-model="post.possede_cajibi" true-label="oui" false-label="non">
                                    {{$labels.possede_cajibi}}
                                </el-checkbox>
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox v-model="post.placards_integres" true-label="oui" false-label="non">
                                    {{$labels.placards_integres}}
                                </el-checkbox>
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox v-model="post.loggia" true-label="oui" false-label="non">
                                    {{ $labels.loggia }}
                                </el-checkbox>
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox v-model="post.cheminee" true-label="oui" false-label="non">
                                    {{ $labels.cheminee }}
                                </el-checkbox>
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox v-model="post.poele_a_bois" true-label="oui" false-label="non">
                                    {{ $labels.poele_a_bois }}
                                </el-checkbox>
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox v-model="post.volets_roulants_electriques" true-label="oui"
                                             false-label="non">
                                    {{$labels.volets_roulants_electriques}}
                                </el-checkbox>
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox v-model="post.climatise" true-label="oui" false-label="non">
                                    {{$labels.climatise}}
                                </el-checkbox>
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox v-model="post.acces_handicapes" true-label="oui" false-label="non">
                                    {{$labels.acces_handicapes}}
                                </el-checkbox>
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox v-model="post.cable_tv" true-label="oui" false-label="non">
                                    {{$labels.cable_tv}}
                                </el-checkbox>
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox v-model="post.est_adapte_pmr" true-label="oui" false-label="non">
                                    {{$labels.est_adapte_pmr}}
                                </el-checkbox>
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox v-model="post.acces_internet_haut_debit" true-label="oui"
                                             false-label="non">
                                    {{ $labels.acces_internet_haut_debit }}
                                </el-checkbox>
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox v-model="post.fibre_optique" true-label="oui" false-label="non">
                                    {{$labels.fibre_optique}}
                                </el-checkbox>
                            </el-col>
                            <el-col :span="24" v-if="post.salle_a_manger == 'oui'">
                                <el-form-item
                                        :label="$labels.surface_salle_a_manger"
                                        prop="surface_salle_a_manger"

                                >
                                    <el-input
                                            v-mask="'#################'" v-model.number="post.surface_salle_a_manger"
                                            type="surface_salle_a_manger"
                                    >
                                        <div slot="append">m²</div>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" v-if="post.sejour == 'oui'">
                                <el-form-item
                                        :label="$labels.surface_sejour"
                                        prop="surface_sejour"

                                >
                                    <el-input v-mask="'#################'" v-model.number="post.surface_sejour"
                                              type="surface_sejour">
                                        <div slot="append">m²</div>
                                    </el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="24">
                                <el-form-item>
                                    <div style="font-size: 12px;">{{ $labels.grenier }}
                                        <el-button class="el-icon-error reset-radio"
                                                   v-if="post.grenier != '' && post.grenier != undefined && post.grenier != null"
                                                   @click="post.grenier = null"
                                                   circle></el-button>
                                    </div>
                                    <el-radio-group v-model="post.grenier">
                                        <el-radio
                                                v-for="grenierChoice in this.$parent.getChoices('grenier')"
                                                :label="grenierChoice"
                                                :value="grenierChoice">
                                        </el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>

                            <el-col :span="24">
                                <el-form-item>
                                    <div style="font-size: 12px;">{{$labels.type_cuisine}}
                                        <el-button class="el-icon-error reset-radio"
                                                   v-if="post.type_cuisine != '' && post.type_cuisine != undefined && post.type_cuisine != null"
                                                   @click="post.type_cuisine = null"
                                                   circle></el-button>
                                    </div>
                                    <el-radio-group v-model="post.type_cuisine">
                                        <el-radio
                                                v-for="cuisineChoice in this.$parent.getChoices('type_cuisine')"
                                                :label="cuisineChoice"
                                                :value="cuisineChoice">
                                        </el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>

                            <el-col :span="24">
                                <el-form-item>
                                    <div style="font-size: 12px;">{{$labels.vitrages}}
                                        <el-button class="el-icon-error reset-radio"
                                                   v-if="post.vitrages != '' && post.vitrages != undefined && post.vitrages != null"
                                                   @click="post.vitrages = null"
                                                   circle></el-button>
                                    </div>
                                    <el-radio-group v-model="post.vitrages">
                                        <el-radio
                                                v-for="natureVitrageChoice in this.$parent.getChoices('vitrages')"
                                                :label="natureVitrageChoice"
                                                :value="natureVitrageChoice">
                                        </el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item :label="$labels.revetement_sol_principal">
                                    <el-select
                                            v-model="post.revetement_sol_principal"
                                            :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                            clearable
                                            filterable
                                    >
                                        <el-option
                                                style="text-transform:capitalize"
                                                v-for="revetementSolChoice in this.$parent.getChoices('revetement_sol_principal')"
                                                :key="revetementSolChoice"
                                                :label="revetementSolChoice"
                                                :value="revetementSolChoice"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item :label="$labels.toiture">
                                    <el-select
                                            v-model="post.toiture"
                                            :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                            clearable
                                            filterable
                                    >
                                        <el-option
                                                style="text-transform:capitalize"
                                                v-for="typeToitureChoice in this.$parent.getChoices('toiture')"
                                                :key="typeToitureChoice"
                                                :label="typeToitureChoice"
                                                :value="typeToitureChoice"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-main>
                </el-container>
            </el-container>
        </ubi-panel>
        <ubi-panel>
            <ubi-form-group :title="$t('posts.energyTitle')">
                <el-row>
                    <el-col :span="24">
                        <el-form-item>
                            <div style="font-size: 12px;">{{$labels.chauffage_type}}
                                <el-button class="el-icon-error reset-radio"
                                           v-if="post.chauffage_type != '' && post.chauffage_type != undefined && post.chauffage_type != null"
                                           @click="post.chauffage_type = null"
                                           circle></el-button>
                            </div>
                            <el-radio-group v-model="post.chauffage_type">
                                <el-radio
                                        v-for="energieChauffageChoice in this.$parent.getChoices('chauffage_type')"
                                        :label="energieChauffageChoice"
                                        :value="energieChauffageChoice">
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.chauffage_energie">
                            <el-select
                                    v-model="post.chauffage_energie"
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="energieChauffageChoice in this.$parent.getChoices('chauffage_energie')"
                                        :key="energieChauffageChoice"
                                        :label="energieChauffageChoice"
                                        :value="energieChauffageChoice"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item>
                            <div style="font-size: 12px;">{{ $labels.eau_chaude_distribution }}
                                <el-button class="el-icon-error reset-radio"
                                           v-if="post.eau_chaude_distribution != '' && post.eau_chaude_distribution != undefined && post.eau_chaude_distribution != null"
                                           @click="post.eau_chaude_distribution = null"
                                           circle></el-button>
                            </div>
                            <el-radio-group v-model="post.eau_chaude_distribution">
                                <el-radio
                                        v-for="eauChaudeDistributionChoice in this.$parent.getChoices('eau_chaude_distribution')"
                                        :label="eauChaudeDistributionChoice"
                                        :value="eauChaudeDistributionChoice">
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </ubi-form-group>
        </ubi-panel>

        <dpe-ges :post="post"></dpe-ges>
        <isolation-thermique-solaire :post="post"></isolation-thermique-solaire>
        <securite-bien :post="post"></securite-bien>

        <ubi-panel>
            <ubi-form-group :title="$t('posts.exteriorTitle')">
                <el-row>
                  <el-col :span="24">
                    <el-form-item
                        :label="$labels.surface_terrain"
                        prop="surface_terrain"

                    >
                      <el-input v-mask="'#################'" v-model.number="post.surface_terrain"
                                type="surface_terrain">
                        <div slot="append">m²</div>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-checkbox v-model="post.terrasse" true-label="oui" false-label="non">
                            {{ $labels.terrasse }}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.balcon" true-label="oui" false-label="non">
                            {{ $labels.balcon }}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.garage" true-label="oui" false-label="non">
                            {{ $labels.garage }}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.possede_parking" true-label="oui" false-label="non">
                            {{$labels.possede_parking}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.possede_box" true-label="oui" false-label="non">
                            {{$labels.possede_box}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.cave" true-label="oui" false-label="non">
                            {{ $labels.cave }}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.avec_toit_terrasse" true-label="oui" false-label="non">
                            {{$labels.avec_toit_terrasse}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.digicode" true-label="oui" false-label="non">
                            {{ $labels.digicode }}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.interphone" true-label="oui" false-label="non">
                            {{ $labels.interphone }}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.videophone" true-label="oui" false-label="non">
                            {{ $labels.videophone }}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.alarme_habitation" true-label="oui" false-label="non">
                            {{ $labels.alarme_habitation }}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.gardien" true-label="oui" false-label="non">
                            {{ $labels.gardien }}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="post.piscine" true-label="oui" false-label="non">
                            {{ $labels.piscine }}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12">
                      <el-checkbox v-model="post.pieds_dans_eau" true-label="oui" false-label="non">
                        {{ $labels.pieds_dans_eau }}
                      </el-checkbox>
                    </el-col>
                    <el-row>
                      <el-col :span="24">
                        <el-form-item :label="$labels.type_jardin" prop="type_jardin">
                          <el-button class="el-icon-error reset-radio" v-if="post.type_jardin != '' && post.type_jardin != undefined && post.type_jardin != null" @click="post.type_jardin = null" circle></el-button>
                          <el-radio-group v-model="post.type_jardin">
                            <el-radio :label="jardinChoice" :value="jardinChoice" v-for="jardinChoice in this.$parent.getChoices('type_jardin')"></el-radio>
                          </el-radio-group>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24" v-if="post.type_jardin == 'privatif'">
                        <el-form-item :label="$labels.surface_jardin" prop="surface_jardin">
                          <el-input v-mask="'#################'" v-model.number="post.surface_jardin" type="surface_jardin">
                            <div slot="append">m²</div>
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <el-form-item>
                          <div style="font-size: 12px;">{{$labels.piscine_type}}
                            <el-button class="el-icon-error reset-radio"
                                       v-if="post.piscine_type != '' && post.piscine_type != undefined && post.piscine_type != null"
                                       @click="post.piscine_type = null"
                                       circle></el-button>
                          </div>
                          <el-radio-group v-model="post.piscine_type">
                            <el-radio
                                v-for="piscineChoice in this.$parent.getChoices('piscine_type')"
                                :label="piscineChoice"
                                :value="piscineChoice">
                            </el-radio>
                          </el-radio-group>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :lg="24">
                        <el-form-item :label="$t('posts.edit.obligationToClearBrush')">
                          <el-radio v-model="post.obligation_debroussaillement" label="oui">{{ $t("general.yes") }}</el-radio>
                          <el-radio v-model="post.obligation_debroussaillement" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-col :span="24" v-if="post.balcon == 'oui'">
                        <el-form-item
                                :label="$labels.nb_balcons"
                                prop="nb_balcons"

                        >
                            <el-input v-mask="'#################'" v-model.number="post.nb_balcons"
                                      type="nb_balcons"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="post.balcon == 'oui'">
                        <el-form-item
                                :label="$labels.surface_balcon"
                                prop="surface_balcon"

                        >
                            <el-input v-mask="'#################'" v-model.number="post.surface_balcon"
                                      type="surface_balcon">
                                <div slot="append">m²</div>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="post.terrasse == 'oui'">
                        <el-form-item
                                :label="$labels.terrasse_surface"
                                prop="terrasse_surface"

                        >
                            <el-input v-mask="'#################'" v-model.number="post.terrasse_surface"
                                      type="terrasse_surface">
                                <div slot="append">m²</div>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="post.garage == 'oui'">
                        <el-form-item
                                :label="$labels.nb_garages"
                                prop="nb_garages"

                        >
                            <el-input v-mask="'#################'" v-model.number="post.nb_garages"
                                      type="nb_garage"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item :label="$labels.exposition">
                                <el-select
                                        v-model="post.exposition"
                                        :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                        clearable
                                        filterable
                                >
                                    <el-option
                                            style="text-transform:capitalize"
                                            v-for="expositionChoice in this.$parent.getChoices('exposition')"
                                            :key="expositionChoice"
                                            :label="expositionChoice"
                                            :value="expositionChoice"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-col :span="24" v-if="post.possede_parking == 'oui'">
                        <el-form-item
                                :label="$labels.nb_parkings"
                                prop="nb_parkings"

                        >
                            <el-input v-mask="'#################'" v-model.number="post.nb_parkings"
                                      type="nb_parking"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item>
                            <div style="font-size: 12px;">{{ $labels.type_stationnement }}
                                <el-button class="el-icon-error reset-radio"
                                           v-if="post.type_stationnement != '' && post.type_stationnement != undefined && post.type_stationnement != null"
                                           @click="post.type_stationnement = null"
                                           circle></el-button>
                            </div>
                            <el-radio-group v-model="post.type_stationnement">
                                <el-radio
                                        v-for="typeStationnementChoice in this.$parent.getChoices('type_stationnement')"
                                        :label="typeStationnementChoice"
                                        :value="typeStationnementChoice">
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="post.cave == 'oui'">
                        <el-form-item
                                :label="$labels.surface_cave"
                                prop="surface_cave"

                        >
                            <el-input v-mask="'#################'" v-model.number="post.surface_cave"
                                      type="surface_cave">
                                <div slot="append">m²</div>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </ubi-form-group>
        </ubi-panel>
        <ubi-panel>
            <ubi-form-group :title="$t('posts.environmentTitle')">
                <el-row>
                    <el-col>
                        <el-form-item>
                            <div style="font-size: 12px;">{{ $t("posts.edit.location") }}
                                <el-button class="el-icon-error reset-radio"
                                           v-if="post.environnement != '' && post.environnement != undefined && post.environnement != null"
                                           @click="post.environnement = null"
                                           circle></el-button>
                            </div>
                            <el-radio-group v-model="post.environnement">
                                <el-radio
                                        v-for="environnementChoice in this.$parent.getChoices('environnement')"
                                        :label="environnementChoice"
                                        :value="environnementChoice">
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.edit.locationProximityAndSituation')">
                            <el-checkbox v-model="post.proche_aeroport" true-label="oui" false-label="non">
                                {{ $t("posts.edit.checkboxAirport") }}
                            </el-checkbox>
                            <el-checkbox v-model="post.proche_sortie_autoroute" true-label="oui" false-label="non">
                                {{ $t("posts.edit.checkboxHighwayExit") }}
                            </el-checkbox>
                            <el-checkbox v-model="post.proche_gare" true-label="oui" false-label="non">
                                {{ $t("posts.edit.checkboxGare") }}
                            </el-checkbox>
                            <el-checkbox v-model="post.proche_bus" true-label="oui" false-label="non">
                                {{ $t("posts.edit.checkboxBus") }}
                            </el-checkbox>
                            <el-checkbox v-model="post.proche_tram" true-label="oui" false-label="non">
                                {{ $t("posts.edit.checkboxTramway") }}
                            </el-checkbox>
                            <el-checkbox v-model="post.proche_parking" true-label="oui" false-label="non">
                                {{ $t("posts.edit.checkboxParking") }}
                            </el-checkbox>
                            <el-checkbox v-model="post.proche_commerces" true-label="oui" false-label="non">
                                {{ $t("posts.edit.checkboxShops") }}
                            </el-checkbox>
                            <el-checkbox v-model="post.proche_centre_commercial" true-label="oui" false-label="non">
                                {{ $t("posts.edit.checkboxMall") }}
                            </el-checkbox>
                            <el-checkbox v-model="post.proche_centre_ville" true-label="oui" false-label="non">
                                {{ $t("posts.edit.checkboxDowntown") }}
                            </el-checkbox>
                            <el-checkbox v-model="post.proche_creche" true-label="oui" false-label="non">
                                {{ $t("posts.edit.checkboxNursery") }}
                            </el-checkbox>
                            <el-checkbox v-model="post.proche_ecole_primaire" true-label="oui" false-label="non">
                                {{ $t("posts.edit.checkboxPrimarySchool") }}
                            </el-checkbox>
                            <el-checkbox v-model="post.proche_college" true-label="oui" false-label="non">
                                {{ $t("posts.edit.checkboxCollege") }}
                            </el-checkbox>
                            <el-checkbox v-model="post.proche_lycee" true-label="oui" false-label="non">
                                {{ $t("posts.edit.checkboxHighSchool") }}
                            </el-checkbox>
                            <el-checkbox v-model="post.proche_universite" true-label="oui" false-label="non">
                                {{ $t("posts.edit.checkboxUniversity") }}
                            </el-checkbox>
                            <el-checkbox v-model="post.espaces_verts" true-label="oui" false-label="non">
                                {{ $t("posts.edit.checkboxGreenSpaces") }}
                            </el-checkbox>
                            <el-checkbox v-model="post.proche_metro" true-label="oui" false-label="non">
                                {{ $t("posts.edit.checkboxSubway") }}
                            </el-checkbox>
                            <el-checkbox v-model="post.belle_vue" true-label="oui" false-label="non">
                                {{ $labels.belle_vue}}
                            </el-checkbox>
                            <el-checkbox v-model="post.vue_sur_mer" true-label="oui" false-label="non">
                                {{ $labels.vue_sur_mer}}
                            </el-checkbox>
                            <el-checkbox v-model="post.est_calme" true-label="oui" false-label="non">
                                {{ $labels.est_calme }}
                            </el-checkbox>
                            <el-checkbox v-model="post.avec_vis_a_vis" true-label="oui" false-label="non">
                                {{ $labels.avec_vis_a_vis }}
                            </el-checkbox>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-col>
                    <br>
                    <el-form-item :label="$t('posts.environmentTitle')">
                        <el-col :span="12">
                            <el-checkbox v-model="post.belle_vue" true-label="oui" false-label="non">
                                {{ $labels.belle_vue}}
                            </el-checkbox>
                        </el-col>
                        <el-col :span="12">
                            <el-checkbox v-model="post.vue_sur_mer" true-label="oui" false-label="non">
                                {{ $labels.vue_sur_mer}}
                            </el-checkbox>
                        </el-col>
                        <el-col :span="12">
                            <el-checkbox v-model="post.est_calme" true-label="oui" false-label="non">
                                {{ $labels.est_calme }}
                            </el-checkbox>
                        </el-col>
                        <el-col :span="12">
                            <el-checkbox v-model="post.avec_vis_a_vis" true-label="oui" false-label="non">
                                {{ $labels.avec_vis_a_vis }}
                            </el-checkbox>
                        </el-col>
                    </el-form-item>
                </el-col>
            </ubi-form-group>
        </ubi-panel>

        <ubi-panel>
            <ubi-form-group :title="$t('posts.propertyConditionTitle')">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-form-item>
                            <el-checkbox v-model="post.recent" true-label="oui" false-label="non">
                                {{ $labels.recent }}
                            </el-checkbox>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item>
                            <div style="font-size: 12px;">{{ $labels.meuble }}
                                <el-button class="el-icon-error reset-radio"
                                           v-if="post.meuble != '' && post.meuble != undefined && post.meuble != null"
                                           @click="post.meuble = null"
                                           circle></el-button>
                            </div>
                            <el-radio-group v-model="post.meuble">
                                <el-radio label="oui">{{ $t("general.yes") }}</el-radio>
                                <el-radio label="non">{{ $t("general.no") }}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="10">
                        <el-form-item
                                :label="$labels.annee_construction"
                                prop="annee_construction"

                        >
                            <el-input v-mask="'#################'" v-model.number="post.annee_construction"
                                      prop="annee_construction"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item
                                :label="$labels.annee_renovation"
                                prop="annee_renovation"

                        >
                            <el-input v-mask="'#################'" v-model.number="post.annee_renovation"
                                      prop="annee_renovation"></el-input>
                        </el-form-item>
                    </el-col>

                </el-row>
            </ubi-form-group>
        </ubi-panel>
    </div>
</template>

<script>
import { getDefinitionDonneeListeeByCode } from '@/services/posts'
import DpeGes from '../Block/DpeGes'
import IsolationThermiqueSolaire from '../Block/IsolationThermiqueSolaire'
import SecuriteBien from "@/pages/posts/forms/Block/SecuriteBien.vue";

export default {
  name: 'PostEditImmoObject2200',
  props: ['post', 'ddList'],
  components: {SecuriteBien, DpeGes, IsolationThermiqueSolaire },
  data () {
    return {}
  },
  computed: {},
  methods: {},
  async beforeMount () {
    let codes = [
      'residence_type',
      'dpe_etiquette_ges',
      'dpe_etiquette_conso',
      'environnement',
      'chauffage_energie',
      'chauffage_type',
      'revetement_sol_principal',
      'vitrages',
      'type_jardin',
      'exposition',
      'grenier',
      'type_cuisine',
      'eau_chaude_distribution',
      'type_stationnement',
      'standing',
      'toiture',
      'mandat_statut',
      'modalites_recuperation_charges_locatives',
      'obligation_debroussaillement'
    ]

    codes = codes.map(function (x) {
      return x.toUpperCase()
    })
    const definitionDonneeListeeByCode = await getDefinitionDonneeListeeByCode({ codes: codes })
    if (definitionDonneeListeeByCode.type == 'error') {
      this.$message({ message: this.$t('error.found'), type: 'error' })
      this.loading = false
      return false
    }
    this.$emit(
      'ddList-update',
      definitionDonneeListeeByCode
    )
  }
}
</script>
